<template>
  <div>
    <div
      v-if="showFilters"
      style="
        width: 100%;
        background-color: #f8f8f8;
        border-radius: 0px;
        border: 1px solid #ddd;
        padding: 0px;
        margin-bottom: 10px;
      "
    >
      <div class="row align-items-center" style="margin: 0px -5px">
        <!--
      <div class="col-1 text-center">
        <h5 style="margin:5px 0px;"><i style="font-size:1.8em;color:#ccc;" class="bi bi-funnel"></i></h5>
      </div>-->
        <div class="col-12">
          <div style="padding: 10px 0px">
            <span style="font-size: 1.1em; color: #666"
              ><i class="bi bi-funnel"></i> Filter by name or country:</span
            >

            <input
              class="form-control"
              @keydown.esc="clearFilters"
              v-model="f_name"
              style="
                border: 1px solid #ddd;
                margin-top: 4px;
                margin-bottom: 6px;
              "
              type="text"
            />

            <a
              v-if="filtersApplied"
              href="#"
              @click.prevent="clearFilters"
              style="padding-top: 6px"
              ><span
                style="
                  color: #666;
                  border: 1px solid #999;
                  border-bottom-width: 2px;
                  border-right-width: 2px;
                  padding: 0px 3px;
                  font-size: 0.85em;
                  border-radius: 3px;
                "
                >Esc</span
              >
              clears filters.</a
            >
            <span style="color: #666" v-else>No filters applied.</span>

            <!--
        <br/>
        <span><strong>Factsheet Types:</strong></span><br/>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
          <label class="form-check-label" for="inlineCheckbox1">Landscape Diagnostic</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2">
          <label class="form-check-label" for="inlineCheckbox2">Basic</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox3" value="option3">
          <label class="form-check-label" for="inlineCheckbox3">Water Resources</label>
        </div>
      -->
          </div>
        </div>
        <!--
      <div class="col-4">

        <br/>
        <span><strong>Sort By:</strong></span><br/>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1">
          <label class="form-check-label" for="inlineRadio1">Name</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2">
          <label class="form-check-label" for="inlineRadio2">Size</label>
        </div>

      </div>-->

        <div class="col-3"></div>
      </div>
    </div>
    <div class="row" style="margin: 0px -5px">
      <Item
        v-for="item in filteredFactsheets"
        :item="item"
        :key="item.identifier"
      ></Item>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Item from "@/components/home/user/Item.vue";

export default {
  props: ["factsheets", "showFilters"],
  data() {
    return {
      f_name: "",
      showFilters: true,
    };
  },
  created() {
    /* Load the main factsheet information via the factsheet API */
    //this.loadFactsheetList();
  },
  components: {
    Item,
  },
  mounted() {},
  computed: {
    filteredFactsheets() {
      if (this.f_name != "") {
        return this.factsheets.filter((item) =>
          item.search_str.match(this.f_name.toLowerCase())
        );
      } else {
        return this.factsheets;
      }
    },
    filtersApplied() {
      return this.f_name != "";
    },
  },
  watch: {
    f_name: function () {},
  },
  methods: {
    clearFilters() {
      this.f_name = "";
    },
  },
  name: "FactsheetCollection",
};
</script>

<style></style>

<style scoped>
input {
  border-radius: 0px;
  padding: 2px;
}
h2 {
  font-size: 1.5em;
  font-weight: 600;
  color: #666;
}
h4 {
  padding-left: 5px;
}
a.item-project {
  font-size: 1.35em;
  padding: 7px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  display: block;
  width: 100%;
  height: 125px;
  margin-bottom: 15px;
}
a.item-project:hover {
  border-color: #ccc;
  background-color: #fff;
}
a.item-project p {
  margin: 5px 0px;
  font-size: 0.8em;
  display: -webkit-box;
  max-width: 400px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-group-item {
  border-radius: 0px;
  padding: 9px;
}
.list-group-item.active {
  background-color: #cce5ff;
}
.list-group-item h5 {
  color: #007bff;
}
a.list-group-item:hover h5 {
  color: #0056b3;
}
.selected {
  background-color: #f5f5f5;
}
.selected h5 {
  font-weight: bold;
}
ul.items {
  border: 0;
  margin: 0;
  padding: 0;
}
p {
  color: #666;
  font-size: 1.2em;
}
</style>
